import { render, staticRenderFns } from "./setState.vue?vue&type=template&id=2efbb268&scoped=true&"
import script from "./setState.vue?vue&type=script&lang=js&"
export * from "./setState.vue?vue&type=script&lang=js&"
import style0 from "./setState.vue?vue&type=style&index=0&id=2efbb268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efbb268",
  null
  
)

export default component.exports